const { RAILS_ENV, REVISION, CURRENT_USER_ID, YEAR } = window;

export const OAUTH_LOGIN_ENABLED = RAILS_ENV !== "production";

export { CURRENT_USER_ID, RAILS_ENV, REVISION, YEAR };

export const GLORYLEAGUE_WEBSITE_URL = "https://gloryleague.basketball";

export const UNRESTRICTED_SPORTS = ["basketball", "futsal"];
